module.exports = __webpack_public_path__ + "img/monitoring-bulldozer-track.a279365b.svg";